import { render } from "./CanvasVista.vue?vue&type=template&id=ed4748bc&scoped=true"
import script from "./CanvasVista.vue?vue&type=script&lang=js"
export * from "./CanvasVista.vue?vue&type=script&lang=js"

import "./CanvasVista.vue?vue&type=style&index=0&id=ed4748bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4748bc"]])

export default __exports__